<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { Primitive } from 'reka-ui';
import { cn } from '@ui/lib/utils.js';
import { type PBadgeVariants, pBadgeVariants } from './index.js';

export type PBadgeProps = PrimitiveProps & {
    variant?: PBadgeVariants['variant'];
    rounded?: boolean;
    class?: HTMLAttributes['class'];
};

const props = defineProps<PBadgeProps>();

const delegatedProps = reactiveOmit(props, 'class', 'rounded');
</script>

<template>
    <Primitive
        data-slot="badge"
        :class="cn(pBadgeVariants({ variant }), rounded ? 'rounded-full' : '', props.class)"
        v-bind="delegatedProps"
    >
        <slot />
    </Primitive>
</template>
